import Channels from "../base/channels";
import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
import { getViewport } from "../utils/utils";
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.VARS = {
      nodeIndex: Array.prototype.indexOf.call(
        this.DOM.view.parentElement.parentElement.childNodes,
        this.DOM.view.parentElement
      ),
    };
    this.FX = {
      mainTitleLines: new SplitText(this.ref.mainTitle, { type: "lines" }),
      mainTitleWords: new SplitText(this.ref.mainTitle, {
        type: "words",
        wordDelimiter: "%",
      }),
      mainTitleChars: [],
      // mainTitleCharsMask: new SplitText(this.ref.mainTitle, {
      //   type: "chars",
      //   charsClass: "tw-overflow-hidden",
      // }),
      // mainTitleChars: new SplitText(this.ref.mainTitle, {
      //   type: "chars",
      //   charsClass: "fx-chars",
      // }),
    };
    for (let word of this.FX.mainTitleWords.words) {
      const test = word.parentElement.classList.contains(
        "util-text-definition"
      );
      if (!test) {
        const instanceMask = new SplitText(word, {
          type: "chars",
          charsClass: "tw-overflow-hidden",
        });
        const instance = new SplitText(word, {
          type: "chars",
          charsClass: "fx-char",
        });
        this.FX.mainTitleChars.push(instance);
        // console.log(instance);
      }
    }
    // console.log(this.FX.mainTitleChars);

    //
    this.funcLaunch = this._reveal.bind(this);

    if (Env.ios == false && this.VARS.nodeIndex > 1) {
      this.makeSticky();
    }

    this._fx();
    Channels.on("launcher::exit", this.funcLaunch);
    Channels.on("transition::end", this.funcLaunch);
  }

  _fx() {
    this.animate();
  }

  _reveal() {
    this.animation.play();
  }

  animate() {
    this.animation = gsap.timeline({ paused: true });

    if (this.FX.mainTitleChars.length) {
      let increment = 0;
      for (let [i, item] of this.FX.mainTitleLines.lines.entries()) {
        const getChars = item.querySelectorAll(".fx-char");
        if (getChars.length > 0) {
          const mod = increment % 2;
          const startFrom = mod == 0 ? -1 : 1;
          const timing = increment > 0 ? "<" : "<+.2";

          this.animation.add(
            [
              gsap.fromTo(
                item.querySelectorAll(".fx-char"),
                {
                  x: `${110 * startFrom}%`,
                },
                {
                  x: "0%",
                  ease: "cubic.out",
                  duration: 1,
                  stagger: 0.02,
                }
              ),
            ],
            timing
          );
          increment++;
        }
      }
    }
    if (this.ref.mainTitle != null) {
      this.animation.add(
        [
          gsap.fromTo(
            this.ref.mainTitle[0].querySelectorAll(".util-text-definition"),
            {
              autoAlpha: 0,
            },
            {
              autoAlpha: 1,
              duration: 1,
              ease: "cubic.out",
            }
          ),
        ],
        "<+.5"
      );
    }
  }

  makeSticky() {
    this.sticky = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top top",
      pin: true,
      pinSpacing: false,
      end: () => {
        const viewport = getViewport();
        return `+=${viewport.height}px`;
      },
      invalidateOnRefresh: true,
    });
  }

  unmount() {
    Channels.removeListener("launcher::exit", this.funcLaunch);
    Channels.removeListener("transition::end", this.funcLaunch);
    if (typeof this.sticky != "undefined") {
      this.sticky.kill();
    }
  }
}
